export default __webpack_public_path__ + "static/media/menuFavorito.6e8d7e70.svg";